import { render } from "./TutorialsView.vue?vue&type=template&id=565d2fd7&scoped=true"
import script from "./TutorialsView.vue?vue&type=script&lang=js"
export * from "./TutorialsView.vue?vue&type=script&lang=js"

import "./TutorialsView.vue?vue&type=style&index=0&id=565d2fd7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565d2fd7"]])

export default __exports__